import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Tooltip } from '@material-ui/core';
import PropTypes from 'prop-types';
import SaveIcon from '@material-ui/icons/Save';

// Estilos del componente
const useStyles = makeStyles(() => ({
    blueButton: {
        backgroundColor: '#15325C',
        color: '#FFFFFF',
        width: '100%',
        height: '100%',
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        borderRadius: '50%',
        boxShadow: '0.125rem 0.25rem 0.625rem #ED2D5D33',
        cursor: 'pointer',
    },
    grayButton: {
        backgroundColor: '#F5F8FF',
        color: '#ED2D5D',
        width: '100%',
        height: '100%',
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        borderRadius: '50%',
        boxShadow: '0.125rem 0.25rem 0.625rem #ED2D5D33',
        cursor: 'pointer',
    },
    redButton: {
        background: 'linear-gradient(90deg, #E02A58, #C00333)',
        color: '#FFFFFF',
        width: '50%',
        height: '80%',
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        borderRadius: '50%',
        boxShadow: '0.125rem 0.25rem 0.625rem #ED2D5D33',
        cursor: 'pointer',
    },
    whiteButton: {
        background: '#FFFFFF',
        color: '#C00333',
        width: '100%',
        height: '100%',
        paddingTop: '0.625rem',
        paddingBottom: '0.625rem',
        borderRadius: '50%',
        boxShadow: '0.125rem 0.25rem 0.625rem #ED2D5D33',
        cursor: 'pointer',
    },
    icon: {
        width: '75%',
        height: 'auto',
    },
}));

const ButtonRound = ({
 caption, colorBase, disabled, onClickEvent,
 }) => {
    const classes = useStyles();

    // Evento de click
    const handleClick = () => {
        if (onClickEvent) {
            onClickEvent();
        }
    };

    /**
     * @name handleColor
     * @desc Se selecciona el color del boton segun sea el caso
     * @param color
     * @returns {string}
     */
    const handleColor = (color) => {
        switch (color) {
            case 'BLUE':
                return classes.blueButton;
            case 'GRAY':
                return classes.grayButton;
            case 'RED':
                return classes.redButton;
            case 'WHITE':
                return classes.whiteButton;
            default:
                return classes.blueButton;
        }
    };

    return (
      <Tooltip title={caption}>
        <Button
          variant="contained"
          className={handleColor(colorBase)}
          classes="rounded-circle"
          disabled={disabled}
          type="submit"
          onClick={handleClick}
        >
          <SaveIcon className={classes.icon} />
        </Button>
      </Tooltip>
    );
};

ButtonRound.defaultProps = {
    disabled: false,
    onClickEvent: null,
};

ButtonRound.propTypes = {
    // Label del boton a mostrar
    caption: PropTypes.string.isRequired,
    // Color para seleccionar como se va a mostrar
    colorBase: PropTypes.string.isRequired,
    // Deshabilita el boton
    disabled: PropTypes.bool,
    // Funcion que dispara el evento de click
    onClickEvent: PropTypes.func,
};

export default ButtonRound;
